export const GET_SELECTABLE_TEMPLATES = 'GET_SELECTABLE_TEMPLATES';
export const TOGGLE_SHOW_TEMPLATES_MODAL = 'TOGGLE_SHOW_TEMPLATES_MODAL';

export const CREATE_TEMPLATE_THUMBNAIL = 'CREATE_TEMPLATE_THUMBNAIL';
export const SET_TEMPLATE_THUMBNAIL_CALLBACK =
  'SET_TEMPLATE_THUMBNAIL_CALLBACK';

export const GET_TEMPLATE_CONTAINERS = 'GET_TEMPLATE_CONTAINERS';
